module.exports = __webpack_public_path__ + "img/ios_1.e98c20ce.png";